// SuperStarHoldingsBreakdown.js
import React from 'react';
import { useSuperStarInstrumentContext } from '../../../context/SuperStarInstrumentContext';

const SuperStarHoldingsBreakdown = () => {
    const { oneQtrInstrument, superStarNameMap } = useSuperStarInstrumentContext();

    if (!oneQtrInstrument) return null;

    return (
        <div className="superstar-details-div">
            {oneQtrInstrument.superStarHoldingsList.map((superStar, index) => (
                <div key={index} className="superstar-details" title={superStar.superStarName}>
                    <div
                        className="each-superstar-div"
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                            height: '100%',
                            backgroundColor: '#eaeaea'
                        }}
                    >
                            <span className="superstar-name" style={{ width: '60px', display: 'flex' }}
                            >
                                {superStarNameMap[superStar.superStarName]}
                            </span>
                        {superStar.holdingLst.map((querterlyHolding, holdingIndex) => (
                            <div
                                key={holdingIndex}
                                className="ss-querterlyHolding-details"
                                style={{ display: 'flex', width: '140px' }}
                            >
                                <span className="querterlyHolding-qtr">{querterlyHolding.Qtr}</span>
                                <span className="querterlyHolding-pct">{querterlyHolding.HoldingPct}</span>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default React.memo(SuperStarHoldingsBreakdown);
